export const infoMessages = {
    campaignPublish: 'This is a demo tenant account. Publishing campaigns is not permitted.',
    campaignDraft: 'This is a demo tenant account. Save as Draft is not permitted.',
    campaignStatus: 'This is a demo tenant account. Modifying campaign status is restricted.',
    campaignEdit: 'This is a demo tenant account. Editing demo campaign is restricted.',
    campaignAdd: 'This is a demo tenant account. Adding/Editing demo campaign is restricted.',
    strategyEdit: 'This is a demo tenant account. Editing demo strategies is restricted.',
    cloneCampaign: 'This is a demo tenant account. Cloning demo campaign is not permitted.',
    cloneStrategy: 'This is a demo tenant account. Cloning demo strategy is not permitted.',
    creativeAdd: 'This is a demo tenant account. Adding demo creatives is not permitted.',
    creativeStatus: 'This is a demo tenant account. Changing the status of a creative is not permitted.',
    creativeUpdate: 'This is a demo tenant account. Updating creatives is not permitted.',
    platformUpdate: 'This is a demo tenant account. Adding or updating platforms is restricted.',
    userStatus: 'This is a demo tenant account. Changing user status is not permitted.',
    userDelete: 'This is a demo tenant account. Deleting users is not permitted.',
    userUpdate: 'This is a demo tenant account. Adding or updating users is restricted.',
    variableEdit: 'This is a demo tenant account. Editing variables is not permitted.',
    variableAdd: 'This is a demo tenant account. Adding variables is not permitted.',
    seatStatus: 'This is a demo tenant account. Changing seat status is restricted.',
    seatResignin: 'This is a demo tenant account. Resigning seats is not permitted.',
    syncCampaign: 'This is a demo tenant account. Syncing campaigns is not permitted.',
    seatDelete: 'This is a demo tenant account. Deleting seats is restricted.',
    seatEdit: 'This is a demo tenant account. Saving seat changes is not permitted.',
    seatAdd: 'This is a demo tenant account. Onboarding new seats is not permitted.',
    profileSave: 'This is a demo tenant account. Saving profile changes is restricted.',
    downloadFile: 'This is a demo tenant account. Downloading file is restricted',
    recommendationPublish: 'This is a demo tenant account. Publishing recommendation is not permitted.',
    recommendationRestrict: 'This is a demo tenant account. Restricting recommendation is not permitted.',
};

// const isDemoAdvertiser = useMemo(() => {
//     return isTenantDemoAdvertiser(tenantId);
//   }, [tenantId]);
